import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'frontend-account-disable',
  templateUrl: './account-disable.component.html',
  styleUrls: ['./account-disable.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AccountDisableComponent {}
